<div class="container-fluid" style="padding:0">
    <div class="row">
        <div class="col-lg-2">
            <app-navbar></app-navbar>
        </div>
        <div class="col-lg-10">
            <div class="row">
                <div class="col-lg-9">
                    <br>
                    <h2>Reporte Registros</h2>
                </div>
                <div class="col-lg-2">
                    
                </div>
            </div>

            <div class="row">
                <div class="col-lg-3">
                    <span class="bold">Selecciona Grupo:</span>
                    <select class="form-control"  #grupoSelect>
                        <option value="0">Seleccione Grupo</option>
                        <option *ngFor = "let grupo of grupos" [value]="grupo.id">{{grupo.nombre}}</option>
                    </select>
                    <br>
                </div>

                <div class="col-lg-3">
                    <span class="bold">Fecha Inicio</span>
                    <div class="input-group">
                        <input id="fecha_inicio" class="form-control"  [(ngModel)]="formulario.fecha_inicio" placeholder="Fecha Inicio yyyy-mm-dd" name="dp1b" ngbDatepicker #dp1b="ngbDatepicker">
                        <div class="input-group-append">
                        <button class="btn btn-outline-secondary calendar" (click)="dp1b.toggle()" type="button">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar-date" viewBox="0 0 16 16">
                            <path d="M6.445 11.688V6.354h-.633A12.6 12.6 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61h.675zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82h-.684zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23z"/>
                            <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
                            </svg>
                        </button>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3">
                    <span class="bold">Fecha Fin</span>
                    <div class="input-group">
                        <input id="fecha_fin" class="form-control"  [(ngModel)]="formulario.fecha_fin" placeholder="Fecha Fin yyyy-mm-dd" name="dp2b" ngbDatepicker #dp2b="ngbDatepicker">
                        <div class="input-group-append">
                        <button class="btn btn-outline-secondary calendar" (click)="dp2b.toggle()" type="button">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar-date" viewBox="0 0 16 16">
                            <path d="M6.445 11.688V6.354h-.633A12.6 12.6 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61h.675zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82h-.684zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23z"/>
                            <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
                            </svg>
                        </button>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3">
                    <br>
                    <button class="btn btn-success" (click)="getRegistros(grupoSelect.value)">Filtrar</button>
                </div>
                
            </div>

            <br>
            <div class="row">
                <div class="col-lg-10">
                    <table  class="table table-striped row-border hover">
                        <thead class="thead-dark">
                            <tr>
                                <td>ID</td>
                                <td>Nombre</td>
                                <td>Monto</td>
                                <td>Fecha de registro</td>
                                <td>Grupo</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let registro of registros">
                                <td>{{registro.id}}</td>
                                <td>{{registro.nombre}}</td>
                                <td>{{registro.total |currency}}</td>
                                <td>{{registro.fecha}}</td>
                                <td>{{registro.grupo}}</td>
                            </tr>
                        
                        </tbody>
                    </table>
                </div>
                
            </div>


        </div>
    </div>
</div>
